const form = {
  formId: "new-user-form",
  formField: {
    taxpayersName: {
      name: "taxpayersName",
      label: "Người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxpayersId: {
      name: "taxpayersId",
      label: "Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    unit: {
      name: "unit",
      label: "Đơn vị tính",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập đơn vị tính",
    },
    bctc: {
      name: "bctc",
      label: "BCTC đã được kiểm toán",
      type: "text",
    },
    htldl: {
      name: "htldl",
      label: "Hỗ trợ lấy dữ liệu từ năm trước",
      type: "text",
    },
    auditOpinion: {
      name: "auditOpinion",
      label: "Ý kiến kiểm toán",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn",
    },
    //--------------//
    fullName: {
      name: "fullName",
      label: "Người lập biểu",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người lập biểu",
    },
    chiefAccountant: {
      name: "chiefAccountant",
      label: "Kế toán trưởng",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên kế toán trưởng",
    },
    certificate: {
      name: "certificate",
      label: "Số chứng chỉ hành nghề:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số chứng chỉ hành nghề",
    },
    signer: {
      name: "signer",
      label: "Giám đốc",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên giám đốc",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
    accountingServices: {
      name: "accountingServices",
      label: "Đơn vị cung cấp dịch vụ kế toán",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên đơn vị cung cấp dịch vụ kế toán",
    },
  },
};

export default form;
